import { FC, useCallback } from "react";
import { FaWind } from "react-icons/fa";
import useFetch from "../../../hooks/useFetch";
import { ParkService } from "../../../services/park/parkService";

interface windFarmCardProps {   
    data?: any;
}

const WindFarmsCard:FC<windFarmCardProps> = ({ data }) => {

    // RENDER 

    return (
        <div className="bg-white dark:bg-gray-800 shadow-lg rounded-lg p-4">
            <div className="flex items-start justify-between">
                <div className="flex flex-col">
                    <h2 className="text-lg font-semibold text-gray-800 dark:text-white">Parques eólicos</h2>
                    <p className="text-sm text-gray-400 dark:text-gray-300">Número total de parques eólicos</p>  
                </div>
                <FaWind className="mt-1 text-primary" />
            </div>

            <div className="flex items-center justify-start mt-4">
                <h2 className="text-3xl font-semibold text-gray-800 dark:text-white">{data ? data : '0'}</h2>
            </div>
        </div>
    );
}

export default WindFarmsCard;